import { useEffect } from "react";
import { refreshCsrfToken } from "lib/fetch";

/**
 * Ensures a fresh CSRF cookie when entering the registration workflow.
 * Long idle periods on early steps can expire the session before the first POST.
 */
export const useRegisterCsrfRefresh = () => {
    useEffect(() => {
        refreshCsrfToken().catch(() => {
            // Best-effort; mutating requests retry after 419 in lib/fetch.
        });
    }, []);
};
